// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { render, prepareUrl } from './common';

/**
 * @class Jsw.DynamicPopupHint
 * @singleton
 */
export const DynamicPopupHint = {
    windowId: 'ajaxTooltipWindow',
    delay: 0.55,
    _isInitialized: false,
    _currentTooltip: null,

    _init(cls) {
        if (this._isInitialized) {
            return;
        }

        this._cls = cls;
        this._initWindowElement();
        this._initWindowEvents();
        this._isInitialized = true;
    },

    _initWindowElement() {
        $(document.body).insert({
            top: `<div id="${this.windowId}" class="${this._cls}" style="display: none; z-index: 10000"></div>`,
        });

        $(this.windowId).update(
            '<table cellspacing="0" class="popup-wrapper"><tbody><tr><td class="popup-container">' +
                '<div class="c1"><div class="c2"><div class="c3"><div class="c4"><div class="c5">' +
                    '<div class="popup-heading">' +
                        '<div class="heading-area">' +
                            '<span class="arrow"></span>' +
                            `<span class="close" id="${this.windowId}-close"></span>` +
                            `<h4><span id="${this.windowId}-title"></span></h4>` +
                        '</div>' +
                    '</div>' +
                    '<div class="popup-content">' +
                        `<div id="${this.windowId}-content" class="popup-content-area"></div>` +
                    '</div>' +
                '</div></div></div></div></div>' +
            '</td></tr></tbody></table>'
        // TODO Need remove this hack when all popup boxes will use DynamicPopupHint component and hardcoded offset will be removed in css
        ).setStyle({ marginTop: 0 });
    },

    _initWindowEvents() {
        $(this.windowId).observe('mouseover', this._onWindowMouseOver.bind(this));
        $(this.windowId).observe('mouseout', this._onWindowMouseOut.bind(this));
        $(`${this.windowId}-close`).observe('click', this._onCloseClick.bind(this));
        $(document.body).observe('click', this._onCloseClick.bind(this));
        $(this.windowId).observe('click', function (event) {
            event.stopPropagation();
        });
    },

    _onWindowMouseOver() {
        this._showWindow();
    },

    _onWindowMouseOut() {
        if (this._currentTooltip.getPlacement() === '') {
            $(this.windowId).hide();
        }
    },

    _onCloseClick() {
        $(this.windowId).hide();
    },

    set(tooltip) {
        this._init(tooltip.getCls());
        const title = tooltip.getTitle();
        const titleElement = $(`${this.windowId}-title`);
        if (false === title) {
            $(`${this.windowId}-title`).update('');
            titleElement.up('.popup-heading').hide();
        } else {
            $(`${this.windowId}-title`).update(title);
            titleElement.up('.popup-heading').show();
        }
        $w('left right top bottom').each(function (className) {
            $(this.windowId).removeClassName(className);
        }, this);
        $(this.windowId).addClassName(tooltip.getPlacement());
        $(this.windowId).down('.heading-area .arrow').toggle(['left', 'right', 'bottom'].indexOf(tooltip.getPlacement()) !== -1);
        $(this.windowId).toggleClassName('popup-box-scrollable', tooltip.getScrollable());
        this._currentTooltip = tooltip;
        this.updateContent(tooltip);
        this._showWindow(tooltip);
    },

    isSet(tooltip) {
        const element = $(this.windowId);
        return element && element.visible() && this._currentTooltip === tooltip;
    },

    unset() {
        const element = $(this.windowId);
        if (element) {
            element.hide();
        }
    },

    updateContent(tooltip) {
        if (this._currentTooltip === tooltip) {
            render($(`${this.windowId}-content`), [
                tooltip.getPlacement() === 'top' ? '<span class="arrow"></span>' : '',
                tooltip.getContent(),
            ], 'inner');
        }
        this._updatePosition();
    },

    _showWindow() {
        $(this.windowId).show();
        this._updatePosition();
    },

    _updatePosition() {
        const element = $(this.windowId);
        const elementWidth = element.getWidth();
        const elementHeight = element.getHeight();
        const headingElementHeight = element.down('.popup-heading').getHeight();
        const tooltipElement = this._currentTooltip.getTargetElement();
        const tooltipElementHeight = tooltipElement.getHeight();
        const tooltipElementWidth = tooltipElement.getWidth();
        let offsetLeft = document.viewport.getScrollOffsets().left;
        let offsetTop = document.viewport.getScrollOffsets().top;
        const elementRight = tooltipElement.cumulativeOffset().left + elementWidth;
        const viewportRight = document.viewport.getWidth() + document.viewport.getScrollOffsets().left;

        switch (this._currentTooltip.getPlacement()) {
            case 'top':
                offsetTop -= elementHeight;
                offsetLeft -= (elementWidth - tooltipElementWidth) / 2;
                break;
            case 'bottom':
                offsetTop += tooltipElementHeight;
                offsetLeft -= (elementWidth - tooltipElementWidth) / 2;
                break;
            case 'left':
                offsetTop -= (headingElementHeight - tooltipElementHeight) / 2;
                offsetLeft -= elementWidth;
                break;
            case 'right':
                offsetTop -= (headingElementHeight - tooltipElementHeight) / 2;
                offsetLeft += tooltipElementWidth;
                break;
        }
        if (elementRight + offsetLeft > viewportRight) {
            offsetLeft -= elementRight + offsetLeft - viewportRight + 10;
        }

        element.clonePosition(tooltipElement, {
            offsetLeft,
            offsetTop,
            setWidth: false,
            setHeight: false,
        });
    },
};

/**
 * @class Jsw.DynamicPopupHint.Instance
 * @extends Jsw.Component
 */
DynamicPopupHint.Instance = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);

        this._targetElement = $(this._getConfigParam('target', ''));
        this._title = this._getConfigParam('title', '');
        this._waitMsg = this._getConfigParam('waitMsg', '');
        this._url = this._getConfigParam('url', '');
        this._cls = this._getConfigParam('cls', 'popup-box');
        this._scrollable = this._getConfigParam('scrollable', true);
        this._placement = this._getConfigParam('placement', '');

        this._content = this._getConfigParam('content', `<div class="ajax-loading">${this._waitMsg}</div>`);
        this._contentLoaded = false;
        this._delayedExecuter = null;
    },

    _initComponentElement() {
        this._initTargetEvents();
    },

    _initTargetEvents() {
        if (this._placement !== '') {
            this._targetElement.observe('click', function (event) {
                event.stop();
                if (DynamicPopupHint.isSet(this)) {
                    DynamicPopupHint.unset();
                } else {
                    DynamicPopupHint.set(this);
                }
            }.bind(this));
        } else {
            this._targetElement.observe('mouseover', this.set.bind(this));
            this._targetElement.observe('mouseout', this.unset.bind(this));
        }
    },

    _loadContent() {
        const context = this;
        new Ajax.Request(prepareUrl(this._url), {
            method: 'get',
            onSuccess(transport) {
                if ('' === transport.responseText) {
                    return;
                }

                context._content = transport.responseText;
                DynamicPopupHint.updateContent(context);
            },
        });

        this._contentLoaded = true;
    },

    setContent(content) {
        this._contentLoaded = true;
        this._content = content;
    },

    set() {
        const context = this;
        this._delayedExecuter = new PeriodicalExecuter(function (pe) {
            DynamicPopupHint.set(context);
            pe.stop();
            this._delayedExecuter = null;
        }, DynamicPopupHint.delay);
    },

    unset() {
        if (this._delayedExecuter) {
            this._delayedExecuter.stop();
            this._delayedExecuter = null;
        }
    },

    getTitle() {
        return this._title;
    },

    getContent() {
        if (!this._contentLoaded && this._url) {
            this._loadContent();
        }

        return this._content;
    },

    getTargetElement() {
        return this._targetElement;
    },

    getCls() {
        return this._cls;
    },

    getScrollable() {
        return this._scrollable;
    },

    getPlacement() {
        return this._placement;
    },
});



// WEBPACK FOOTER //
// ./jsw/dynamic-popup-hint.js